module.exports = __webpack_public_path__ + "img/8.4fca3d78.png";